import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const dropboxSign = defineConnector({
  identifier: "dropboxSign",
  name: "Dropbox Sign",
  tagLine: "Electronic signature platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.hellosign\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a Dropbox Sign app",
      items: [
        {
          kind: "markdown",
          content:
            "Open the [Dropbox Sign quickstart](https://developers.hellosign.com/docs/openapi/quickstart/#create-an-api-app) and create an API app in the Dropbox Sign dashboard. Copy the client ID and client secret from the app settings.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/dropboxSign/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Dropbox Sign account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Dropbox Sign account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://app.hellosign.com/oauth/authorize",
    tokenEndpoint: () => "https://app.hellosign.com/oauth/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.hellosign.com/",
  },
});
